module.exports = __webpack_public_path__ + "static/media/studyblue.2a51eafd.svg";